import PageHero from "../components/PageHero";
import Framework from "../components/sections/Framework";
import { CALENDLY_URL } from "../lib/site";

export default function FrameworkPage() {
  return (
    <div data-testid="framework-page">
      <PageHero
        eyebrow="The TinkerShift Framework"
        accent="#0055FF"
        title={
          <>
            Create. Build. Solve. Share.{" "}
            <span className="bg-[#00C2B8] px-2 inline-block">Adapt.</span>
          </>
        }
        intro="Our 5-pillar framework gives schools and libraries a shared language and practical pathway for designing future-ready learning experiences."
        ctaLabel="Book a Discovery Call"
        ctaTo={CALENDLY_URL}
        ctaExternal
        secondaryLabel="Talk to us"
        secondaryTo="/contact"
      />
      <Framework />
    </div>
  );
}
